import { render, staticRenderFns } from "./ntmUpload.vue?vue&type=template&id=9c071422"
import script from "./ntmUpload.vue?vue&type=script&lang=js"
export * from "./ntmUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports